import * as CollaboratorsActions from '../collaborators';
import * as GroupsActions from '../groups';
import * as GroupsSelectors from '../../selectors/groups';
import * as CurrentsSelectors from '../../selectors/current';

export const initializeGroup =
    (groupType, filerrIds, recipientIds) =>
        (dispatch) =>
            dispatch(GroupsActions.createGroup(groupType, filerrIds))
                .then(() => dispatch(addCollaboratorsToNewGroup(groupType, recipientIds)));

const addCollaboratorsToNewGroup =
    (groupType, recipientIds) =>
        (dispatch, getState) => {
            const groupId = GroupsSelectors.getGroupIdByType(getState(), groupType);
            const userId = CurrentsSelectors.getCurrentUserId(getState());

            const currentCollaborator = collaboratorContract(userId, groupId);

            const recipientsCollaborators = recipientIds.map(
                (userId) => collaboratorContract(userId, groupId)
            );

            return dispatch(
                CollaboratorsActions.createCollaborators([
                    ...recipientsCollaborators,
                    currentCollaborator
                ])
            );
        };

const collaboratorContract = (userId, groupId) => ({
    userId,
    groupId
});
